// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__21Iz6","left":"StickyBox_left__uwH6c","right":"StickyBox_right__2uznZ"};